import { render, staticRenderFns } from "./GeneralLedgerIncomeStatement.vue?vue&type=template&id=c2eb9dfa&scoped=true&"
import script from "./GeneralLedgerIncomeStatement.vue?vue&type=script&lang=js&"
export * from "./GeneralLedgerIncomeStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2eb9dfa",
  null
  
)

export default component.exports